import React, { useEffect, useMemo, useState, useCallback } from 'react';
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Modal from 'react-bootstrap/Modal';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify';
import Button from 'react-bootstrap/esm/Button';
import FormCustom from '../../Components/Form/FormCustom';
import Input from '../../Components/Form/Input';
import Select from '../../Components/Form/Select';
import CustomersList from '../Customers/CustomersList';
import SweetAlert from '../../Components/SweetAlert/SweetAlert';

const BotPreOrders = () => {
  const [ready, setReady] = useState(false);
  const [filters, setFilters] = useState({
    status: 'PENDING_CALL_CENTER',
    date_start: Helpers.date.get({
      format: '%Y-%m-%d',
      addDays: -7
    }),
    date_end: Helpers.date.get({
      format: '%Y-%m-%d'
    }),
  });
  const [rows, setRows] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const [showCustomers, setShowCustomers] = useState(false);
  const [customers, setCustomers] = useState(null);
  const [typeFormatPays, setTypeFormatPays] = useState([]);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetail, setOrderDetail] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [approveForm, setApproveForm] = useState({
    p_id_customers: '',
    p_id_type_format_pay: '',
    p_has_invoice_doc: 0,
  });
  const [approving, setApproving] = useState(false);
  const [showAlertReject, setShowAlertReject] = useState(false);
  const [idToReject, setIdToReject] = useState(null);
  const [loadSubmitReject, setLoadSubmitReject] = useState(false);

  const statusOptions = [
    { label: 'Pendientes', value: 'PENDING_CALL_CENTER' },
    { label: 'Aprobados', value: 'APPROVED' },
    { label: 'Rechazados', value: 'REJECTED' },
  ];

  const cboStatus = useMemo(() => {
    const found = statusOptions.find(o => o.value === filters.status);
    return found ? { label: found.label, value: found.value } : null;
  }, [filters.status,]);

  const cboTypeFormatPay = useMemo(() => {
    if (!approveForm.p_id_type_format_pay) return '';
    const found = typeFormatPays.find(t => parseInt(t.id_type_format_pay) === parseInt(approveForm.p_id_type_format_pay));
    if (!found) return '';
    return { label: found.name_format_pay, value: found.id_type_format_pay };
  }, [approveForm.p_id_type_format_pay, typeFormatPays]);

  const fetchList = () => {
    setIsProcessing(true);
    console.log(filters);
    Controllers.bot.preorders_list(filters)
      .then(res => {
        setRows(res.data || []);
      })
      .catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => setIsProcessing(false));
  };

  const fetchTypeFormatPay = () => {
    Controllers.type_format_pay.get_type_format_pay()
      .then(res => setTypeFormatPays(res.data || []))
      .catch(() => setTypeFormatPays([]));
  };

  useEffect(() => {
    fetchTypeFormatPay();
    setReady(true);
  }, []);

  useEffect(() => {
    if (ready) fetchList();
  }, [ready]);

  const viewOrder = (id) => {
    Controllers.bot.preorder_get({ id })
      .then(res => {
        setOrderDetail(res.data);
        setModalShow(true);
      })
      .catch(req => Helpers.promise.catch({ req, toast }));
  };

  const handleReject = (id) => {
    setIdToReject(id);
    setShowAlertReject(true);
  };

  const confirmReject = () => {
    if (!idToReject) return;
    setLoadSubmitReject(true);
    Controllers.bot.preorder_reject({ id: idToReject })
      .then(() => {
        toast.success('Pre-orden rechazada');
        setShowAlertReject(false);
        setIdToReject(null);
        fetchList();
        if (selectedOrder && selectedOrder.id_bot_order === idToReject) {
          setSelectedOrder(null);
          setOrderDetail(null);
        }
      })
      .catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => setLoadSubmitReject(false));
  };

  const handleApprove = () => {
    if (!selectedOrder) return;
    if (!approveForm.p_id_customers) {
      toast.warning('Seleccione el cliente');
      return;
    }
    if (!approveForm.p_id_type_format_pay) {
      toast.warning('Seleccione la forma de pago');
      return;
    }

    setApproving(true);
    Controllers.bot.preorder_approve({
      id: selectedOrder.id_bot_order,
      data: approveForm
    }).then(res => {
      toast.success('Venta creada correctamente');
      fetchList();
      setSelectedOrder(null);
      setOrderDetail(null);
      setApproveForm({
        p_id_customers: '',
        p_id_type_format_pay: '',
        p_has_invoice_doc: 0,
      });
    }).catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => setApproving(false));
  };

  const dtRows = useMemo(() => <ReactDataTableBootstrap
    head={[
      [
        { name: 'id_bot_order', text: 'ID', align: 'center' },
        {
          name: 'created_at', text: 'Fecha', align: 'center', render: r => (
            Helpers.date.get({ date: r.created_at, format: '%d/%m/%Y %H:%i' })
          )
        },
        { name: 'conversation_id', text: 'Teléfono', align: 'center' },
        { name: 'name_branch_office', text: 'Sucursal', align: 'center' },
        { name: 'customer_name', text: 'Cliente (texto)', align: 'center' },
        { name: 'total_qty', text: 'Cant. Items', align: 'center' },
        {
          name: 'status', text: 'Estado', align: 'center', render: r => {
            const text = r.status === 'APPROVED' ? 'Aprobado' : r.status === 'REJECTED' ? 'Rechazado' : 'Pendiente';
            const variant = r.status === 'APPROVED' ? 'success' : r.status === 'REJECTED' ? 'danger' : 'warning';
            return (
              <div className={'badge badge-' + variant}>
                {text}
              </div>
            );
          }
        },
        {
          name: 'actions', text: 'Acciones', align: 'center', render: r => (
            <div>
              <Button size="xs" variant="info" className="mr-1" onClick={() => {
                setSelectedOrder(r);
                viewOrder(r.id_bot_order);
              }}>
                <i className="fa fa-eye"></i>
              </Button>
              {r.status === 'PENDING_CALL_CENTER' && <>
                <Button size="xs" variant="success" className="mr-1" onClick={() => {
                  setSelectedOrder(r);
                  viewOrder(r.id_bot_order);
                }}>
                  <i className="fa fa-check"></i>
                </Button>
                <Button size="xs" variant="danger" onClick={() => handleReject(r.id_bot_order)}>
                  <i className="fa fa-times"></i>
                </Button>
              </>}
            </div>
          )
        },
      ],
    ]}
    columnOrder="id_bot_order"
    orderDirection="desc"
    rows={rows}
    pageLength={50}
    isProcessing={isProcessing}
  />, [rows, isProcessing]);

  return (
    <Card>
      <Card.Header className="justify-content-between">
        <span>Pre-órdenes del Bot</span>
      </Card.Header>
      <Card.Body>
        <FormCustom viewSubmit={false} className="mb-3" onSubmit={_ => {
          fetchList();
        }}>
          <Select
            icon="fa fa-list"
            text="Estado"
            classNameParent="col-6 col-md-4 mb-2"
            options={statusOptions}
            value={cboStatus}
            onChange={e => setFilters({ ...filters, status: e.value })}
          />
          <Input
            classNameParent="col-6 col-md-4 mb-2"
            icon="far fa-calendar"
            placeholder="Fecha Inicio"
            text="Fecha Inicio"
            value={filters.date_start}
            onChange={e => setFilters({ ...filters, date_start: e.currentTarget.value })}
            required
            type="date"
          />
          <Input
            classNameParent="col-6 col-md-4 mb-2"
            icon="far fa-calendar"
            placeholder="Fecha Fin"
            text="Fecha Fin"
            value={filters.date_end}
            onChange={e => setFilters({ ...filters, date_end: e.currentTarget.value })}
            append={[<Button type="submit">
              <i className="fa fa-search mr-2"></i>Buscar
            </Button>]}
            required
            type="date"
          />
        </FormCustom>

        {dtRows}

        <Modal show={!!(selectedOrder && orderDetail && modalShow)} onHide={() => {
          setModalShow(false);
          setSelectedOrder(null);
          setOrderDetail(null);
        }} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title as="div">
              {selectedOrder ? `Pre-orden #${selectedOrder.id_bot_order}` : 'Pre-orden'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedOrder && orderDetail && <div className="row">
              <div className="col-12 col-md-6">
                <div><strong>Sucursal:</strong> {orderDetail.header.name_branch_office}</div>
                <div><strong>Conversación:</strong> {orderDetail.header.conversation_id}</div>
                <div><strong>Cliente (texto):</strong> {orderDetail.header.customer_name || ''}</div>
              </div>
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-12">
                    <small className="text-muted">Aprobación</small>
                  </div>
                  <div className="col-12 col-md-6">
                    <Input
                      text="Cliente Seleccionado"
                      placeholder="Seleccione cliente"
                      value={customers?.full_name_customers || ''}
                      disabled
                      append={[
                        <Button size="sm" onClick={() => setShowCustomers(true)}><i className="fa fa-search"></i></Button>
                      ]}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <Select
                      text="Forma de Pago"
                      options={typeFormatPays.map(t => ({ label: t.name_format_pay, value: t.id_type_format_pay }))}
                      value={cboTypeFormatPay}
                      onChange={e => setApproveForm({ ...approveForm, p_id_type_format_pay: e.value })}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 mt-3">
                <div className="table-responsive">
                  <table className="table table-sm table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Clave</th>
                        <th>Producto</th>
                        <th className="text-center">Pack</th>
                        <th className="text-center">Cantidad</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderDetail.items.map(it => (
                        <tr key={it.id_bot_order_item}>
                          <td className="text-center">{it.key_product}</td>
                          <td>{it.name_product}</td>
                          <td className="text-center">
                            <div className={'badge badge-' + (parseInt(it.pack_product) === 1 ? 'success' : 'secondary')}>
                              {parseInt(it.pack_product) === 1 ? 'SI' : 'NO'}
                            </div>
                          </td>
                          <td className="text-center">{it.qty}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setModalShow(false);
              setSelectedOrder(null);
              setOrderDetail(null);
            }}>
              Cerrar
            </Button>
            {selectedOrder && selectedOrder.status === 'PENDING_CALL_CENTER' && (
              <Button variant="success" onClick={handleApprove} disabled={approving}>
                {approving ? <i className="fa fa-circle-notch fa-spin"></i> : <i className="fa fa-check"></i>}
                <span className="ml-2">Aprobar y crear venta</span>
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <CustomersList
          showButttonAdd={false}
          show={showCustomers}
          onHide={() => setShowCustomers(false)}
          typeList="SALE"
          customersAdded={approveForm.p_id_customers ? [{ id_customers: approveForm.p_id_customers }] : []}
          onAddCustomers={({ idCustomers, fullNameCustomers, idTypePrice, customers }) => {
            setApproveForm({ ...approveForm, p_id_customers: idCustomers });
            setCustomers({ ...customers, full_name_customers: fullNameCustomers, id_type_price: idTypePrice });
            setShowCustomers(false);
          }}
        />

        <SweetAlert
          icon="delete"
          show={showAlertReject}
          showCancelButton
          title={<>¿Rechazar pre-orden?</>}
          subtitle={<>#{idToReject}</>}
          confirmButtonText="¡Sí, rechazar!"
          cancelButtonText="Cancelar"
          loadSubmit={loadSubmitReject}
          onCancel={() => {
            setShowAlertReject(false);
            setIdToReject(null);
          }}
          onConfirm={confirmReject}
        />
      </Card.Body>
    </Card>
  );
};

export default BotPreOrders;
